import React from 'react'
import Loading from '@components/SuspenseLoading/Loading'
import {getResizedImageSSR_image} from '@data/queries/components/__generated__/getResizedImageSSR'
import isServerSide from '@helpers/misc/isServerSide'
import useResizedImageURL from '@hooks/useResizedImageURL'

import styles from './styles.module.css'

export default function Image(props: {file?: {_id: string}; ssrImage?: getResizedImageSSR_image}) {
  const {file} = props
  const queriedUrl = useResizedImageURL(
    {fileId: file ? file._id : null, width: 500, height: 300},
    {partial: true}
  )

  const url = queriedUrl ? queriedUrl : props.ssrImage?.resizedURL
  if (isServerSide() && !props.ssrImage?.resizedURL) {
    console.warn(
      'Could not fetch store image while doing SSR. This should be fixed for an optimized experience'
    )
    return <Loading />
  }

  if (!file) return null

  return <img className={styles.image} src={url} alt="" />
}
